/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmuaApprovalDecision } from './vmuaApprovalDecision';


/**
 * Detailed view of an VMUA approval request, including all its decisions.
 */
export interface VmuaApprovalDetails { 
    /**
     * Unique identifier of the approval request.
     */
    requestId?: string;
    /**
     * The organization UUID this request belongs to.
     */
    orgId?: string;
    /**
     * The entity (e.g. vCenter UUID) the operation targets.
     */
    entityId?: string;
    /**
     * Key ID used to encrypt the original request.
     */
    keyId?: string;
    /**
     * The operation that was requested.
     */
    operation?: string;
    /**
     * Resource targeted by the operation.
     */
    resourceId?: string;
    /**
     * The user who initiated the request.
     */
    requestedBy?: string;
    /**
     * Timestamp when the request was issued.
     */
    requestedAt?: Date;
    /**
     * Timestamp after which the approval request is no longer valid.
     */
    expiresAt?: Date;
    /**
     * List of all decisions made for this request.
     */
    decisions?: Array<VmuaApprovalDecision>;
}

